import React from 'react'
import { Text, StyleSheet } from 'react-native'
import PropTypes from 'prop-types'

type QuestionTextProps = {
  /** The "answer" to a "question". */
  name: string,
}

/** 
 * The "answer" to a "question". 
 * @component
 */
export const QuestionText = ({name}: QuestionTextProps) => (
  <Text style={styles.container}>
    {name}  
  </Text>
)

QuestionText.propTypes = {
  name: PropTypes.string.isRequired,
}

const styles = StyleSheet.create({
  container: {
    fontSize: 16,
    color: '#333',
    fontWeight: 'bold',
  }
})